import { useState, useCallback } from "react";
import { Modal } from "antd";
import { Spinner } from "reactstrap";

export const useConfirm = () => {
  const [modalState, setModalState] = useState({
    visible: false,
    title: "",
    content: "",
    onOk: () => { },
    onCancel: () => { },
  });

  const confirm = ({ title, content, onOk, onCancel }) => {
    setModalState({
      visible: true,
      title,
      content,
      onOk: onOk || (() => { }),
      onCancel: onCancel || (() => { }),
    });
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, visible: false }));
  };

  const handleOk = () => {
    const shouldClose = modalState.onOk({ closeModal });
    if (shouldClose !== false) {
      closeModal();
    }
  };

  const handleCancel = () => {
    modalState.onCancel();
    setModalState((prev) => ({ ...prev, visible: false }));
  };

  const ModalComponent = useCallback(
    ({ loading = false, ...props }) => {
      return (

        <>
          <Modal
            {...props}
            open={modalState.visible}
            title={modalState.title}
            onOk={handleOk}
            onCancel={loading ? undefined : handleCancel}
            okText={loading ? <Spinner size="sm" /> : modalState.okText}
            cancelText={modalState.cancelText}
          >
            {modalState.content}
          </Modal >
        </>
      );
    },
    [modalState]
  );

  return { confirm, ModalComponent };
};
